import { Authority } from "@/shared/security/authority";

export default [
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/SettingsPage.vue"),
    meta: { authorities: [Authority.ADMIN, Authority.MODERATOR] }
  },
  {
    path: "/eventLog",
    name: "EventLog",
    component: () => import("@/views/EventLog.vue"),
    meta: { authorities: [Authority.ADMIN, Authority.MODERATOR] }
  }
];
